import { apiFetch, ApiError, type BoardLoadResponse } from "../../api/client";

/** Загрузка доски для невидимого просмотра админом. */
export async function fetchAdminSpectateBoard(
  boardId: string
): Promise<BoardLoadResponse | null> {
  try {
    return await apiFetch<BoardLoadResponse>(
      `/api/v1/admin/boards/${encodeURIComponent(boardId)}`
    );
  } catch (e) {
    if (e instanceof ApiError && (e.status === 403 || e.status === 404)) {
      return null;
    }
    throw e;
  }
}

export function boardLoadErrorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.status === 403) {
      return "Нет прав для невидимого просмотра этой доски.";
    }
    if (e.status === 404) {
      return "Доска не найдена или у вас нет доступа.";
    }
    return e.message;
  }
  if (e instanceof Error) return e.message;
  return "Ошибка загрузки";
}
